export const Automation = () => {
    return (
        <svg aria-hidden="true" viewBox="0 0 48 48" fill="currentColor">
            <path d="M11 28L27 6V20H37L21 42V28H11Z" />
        </svg>
    );
};
